import { JSX, Match, Show, Switch } from "solid-js";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";
import HubbleImage from "~/widgets/hubble_image";
import { VoucherGenerationBrandCard } from "~/components/brand_l2/voucher_generation_brand_card";
import { useTelescopeContext } from "@hubble/telescope";

/**
 * Brand card section displaying the hero image
 * Shows Hubble logo for webstore users
 * Responsive: full width on mobile, constrained on desktop
 */

/**
 * Hero-sized Brand Card component using Telescope design system
 * Displays the full-width hero image with optional discount badge and Hubble logo
 */
export function BrandCardSection(): JSX.Element {
  const { routeData } = useBrandl2WebstoreTelescopeContext();
  const { components } = useTelescopeContext();

  return (
    <div class={`relative aspect-[541/316] w-full`}>
      <Switch>
        <Match when={routeData()?.brand.voucherProductMetadata.heroImageUrl}>
          <HubbleImage
            class=" w-full rounded-3xl"
            src={routeData()!.brand.voucherProductMetadata.heroImageUrl}
            alt={routeData()!.brand.voucherProductMetadata.title}
          />
        </Match>
        <Match when={true}>
          <VoucherGenerationBrandCard
            plainLogoUrl={
              routeData()!.brand.voucherProductMetadata.plainLogoUrl
            }
            cardBackgroundColor={
              routeData()!.brand.voucherProductMetadata.cardBackgroundColor
            }
            showHubbleLogo={true}
          />
        </Match>
      </Switch>
    </div>
  );
}
